(() => {
  // Cart offer card (rc-cart-upsell). Delegated, so it keeps working after Dawn re-renders the cart items.
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const post = async (path, body) => {
    const response = await fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
    }
    return response.json();
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-rc-upsell-add], [data-rc-upsell-swap]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    const card = button.closest('[data-rc-upsell]');
    const error = card && card.querySelector('[data-rc-upsell-error]');
    button.setAttribute('aria-busy', 'true');
    if (error) error.hidden = true;
    try {
      const id = parseInt(button.dataset.variant, 10);
      if (button.hasAttribute('data-rc-upsell-swap')) {
        // Liquid prints line item properties as [[name, value], ...]; the Ajax API wants an object.
        let properties = {};
        try {
          const raw = JSON.parse(button.dataset.props || '{}') || {};
          properties = Array.isArray(raw) ? Object.fromEntries(raw.filter((pair) => pair[1] !== '')) : raw;
        } catch (e) {}
        const quantity = parseInt(button.dataset.qty, 10) || 1;
        await post('cart/add.js', { items: [{ id, quantity, properties }] });
        await post('cart/change.js', { id: button.dataset.key, quantity: 0 });
      } else {
        await post('cart/add.js', { items: [{ id, quantity: 1 }] });
      }
      window.location.reload();
    } catch (err) {
      button.removeAttribute('aria-busy');
      if (error) {
        error.textContent = err.message;
        error.hidden = false;
      }
    }
  });
})();
